import identifierInput from '../identifier-input/identifier-input.vue';
import accountNumberInput from '../account-number-input/account-number-input.vue';
import passwordInput from '../password-input/password-input.vue';
import { useSeon } from '../../../common/js/seon/v5/seon-composable';
import { useDirektIbCookieHandler } from '../../../common/js/composables/direkt-ib-cookie-handler';

const COOKIE_USER_VALIDATED = 'portal-netbank-login-validated';
export default {
	data() {
		return {
			model: {
				identifier: null,
				password: null,
				identifyTransaction: false,
				rememberMe: false
			},
			savedAccountNumbers: [],
			selectedAccountNumber: null,
			submitted: false,
			cookiePortalIdName: null,
			cookieUserDataName: null,
			cookieAdditionalName: null,
			seonData: null
		};
	},
	props: {
		structureId: {
			required: true
		}
	},
	components: {
		identifierInput,
		accountNumberInput,
		passwordInput
	},
	setup() {
		const { setDirektCookie } = useDirektIbCookieHandler();
		const { getSession } = useSeon();
		return {
			setDirektCookie,
			getSession
		};
	},
	watch: {
		selectedAccountNumber(val) {
			this.model = val;
		},
		'model.rememberMe'(val) {
			if (!val && this.savedAccountNumbers.length == 1) {
				this.deleteAccountNumber(this.savedAccountNumbers[0].identifier);
			}
		}
	},
	methods: {
		async login(type) {
			try {
				this.seonData = await this.getSession();
			} catch (err) {
				console.info('No seon');
			}
			if (!this.$v.$invalid) {
				let filteredAccountNumbers = this.savedAccountNumbers
					.filter((accountNumber) => accountNumber.identifier != this.model.identifier)
					.map((accountNumber) => {
						accountNumber.lastSaved = false;
						return accountNumber;
					});
				let model = Object.assign({ lastSaved: true }, this.model);
				model.password = '';
				filteredAccountNumbers.push(model);
				this.savedAccountNumbers = filteredAccountNumbers;
				if (this.model.rememberMe) {
					this.saveCookie();
				}
				this.$cookie.set(COOKIE_USER_VALIDATED, true, { expires: '10Y', secure: true, SameSite: 'strict' });
				this.setDirektCookie();
				this.$nextTick(() => {
					this.submitForm();
				});
			}
			this.showFieldErrors();
			this.submitted = true;

			if (this.$v.$invalid) {
				if (type === 'account-number') {
					this.$gtm.trackEvent({
						event: 'direktBankLoginFailed',
						loginType: 'accountNumber',
						loginDetails: 'inactiveButton'
					});
				} else {
					// type === identifier
					this.$gtm.trackEvent({
						event: 'direktBankLoginFailed',
						loginType: 'personalIdLogin',
						loginDetails: 'inactiveButton'
					});
				}
			}
		},
		selectAccountNumber(identifier) {
			let filteredAccountNumbers = this.savedAccountNumbers.filter((accountNumber) => accountNumber.identifier == identifier);
			this.selectedAccountNumber = Object.assign({}, filteredAccountNumbers[0]);
		},
		deleteAccountNumber(identifier) {
			const filteredAccountNumbers = this.savedAccountNumbers.filter((accountNumber) => accountNumber.identifier != identifier);
			const hasLastSaved = filteredAccountNumbers.every((accountNumber) => accountNumber.lastSaved);
			if (filteredAccountNumbers.length && !hasLastSaved) {
				filteredAccountNumbers[filteredAccountNumbers.length - 1].lastSaved = true;
				this.selectAccountNumber(filteredAccountNumbers[filteredAccountNumbers.length - 1].identifier);
			}
			this.savedAccountNumbers = filteredAccountNumbers;
			this.saveCookie();
		},
		saveCookie() {
			this.$cookie.set(this.cookieUserDataName, JSON.stringify(this.savedAccountNumbers), {
				expires: '10Y',
				secure: true,
				SameSite: 'strict'
			});
			this.$cookie.set(
				this.cookieAdditionalName,
				JSON.stringify({
					identifyTransaction: this.model.identifyTransaction,
					rememberMe: this.model.rememberMe
				}),
				{ expires: '10Y', secure: true, SameSite: 'strict' }
			);
		},
		loadCookie() {
			let accountCookie = this.$cookie.get(this.cookieUserDataName);
			if (accountCookie) {
				this.savedAccountNumbers = JSON.parse(accountCookie);
				let lastSavedAccountNumber = this.savedAccountNumbers.filter((accountNumber) => accountNumber.lastSaved === true);
				if (lastSavedAccountNumber.length) {
					this.selectAccountNumber(lastSavedAccountNumber[0].identifier);
				}
			}
			let additionalCookie = this.$cookie.get(this.cookieAdditionalName);
			if (additionalCookie) {
				let additional = JSON.parse(additionalCookie);
				this.model.identifyTransaction = additional.identifyTransaction;
				this.model.rememberMe = additional.rememberMe;
			}
			let visited = this.$cookie.get(COOKIE_USER_VALIDATED);
			if (visited) {
				this.$emit('on-has-saved-account-number');
			}
		}
	},
	created() {
		this.loadCookie();
	}
};